// Textes de l'interface : un fichier JSON par langue et par groupe de pages (locales/<langue>/<groupe>.json).
// Le français est embarqué (langue par défaut et de secours) ; les autres langues sont chargées à la demande.
// Ajouter une langue = ajouter un dossier locales/<code>/ (mêmes fichiers que fr/) et une entrée dans LANGUAGE_INFO (../languages.tsx).
import type { Dictionary } from './types';

const frModules = import.meta.glob<{ default: Dictionary }>('./fr/*.json', { eager: true });
const lazyModules = import.meta.glob<{ default: Dictionary }>(['./*/*.json', '!./fr/*.json']);

/** Dictionnaire français complet : référence des clés et texte de secours. */
export const fr: Dictionary = Object.assign({}, ...Object.values(frModules).map(m => m.default));

/** Codes des langues dont les fichiers existent (français en tête). */
export const AVAILABLE_LANGUAGES: string[] = ['fr', ...new Set(Object.keys(lazyModules).map(p => p.split('/')[1]))];

/** Charge toutes les traductions d'une langue. */
export async function loadDictionary(lang: string): Promise<Dictionary> {
  if (lang === 'fr') return fr;
  const files = Object.keys(lazyModules).filter(p => p.startsWith(`./${lang}/`));
  if (!files.length) throw new Error(`langue inconnue : ${lang}`);
  const parts = await Promise.all(files.map(p => lazyModules[p]()));
  return Object.assign({}, ...parts.map(m => m.default));
}
